
import Vue from 'vue'

import sinisterTransformer from './../../transformers/sinister/road'

export default (sinister) => {
  const payload = sinisterTransformer.send(sinister)
  return Vue.$http.put(`sinisters/roads/${payload.id}/`, payload)
    .then(response => {
      return sinister
    })
}



// WEBPACK FOOTER //
// ./src/services/sinister/updateRoadSinister.js